import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import styles from './CartPage.module.css';

const formatPrice = (n) => `₦${Number(n).toLocaleString()}`;

export default function CartPage() {
  const { items, remove, updateQty, clear, total, count } = useCart();
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();

  // Delivery fee: ₦1,000 per item qty
  const deliveryFee = items.reduce((sum, i) => sum + 1000 * i.qty, 0);
  const grandTotal  = total + deliveryFee;

  const handleCheckout = () => {
    if (!isLoggedIn) {
      navigate('/login', { state: { from: '/cart' } });
      return;
    }
    navigate('/checkout');
  };

  if (items.length === 0) return (
    <div className={styles.empty}>
      <span>🛒</span>
      <h2>Your cart is empty</h2>
      <p>Add some products and they'll appear here</p>
      <Link to="/shop" className={styles.shopBtn}>Start shopping</Link>
    </div>
  );

  return (
    <div className={styles.page}>
      <div className={`container ${styles.layout}`}>

        {/* Items */}
        <div className={styles.items}>
          <div className={styles.header}>
            <h1 className={styles.title}>
              Your cart <span className={styles.countBadge}>{count}</span>
            </h1>
            <button className={styles.clearBtn} onClick={clear}>Clear all</button>
          </div>

          {items.map(item => (
            <div key={item.id} className={styles.item}>
              <img src={item.image} alt={item.name} className={styles.img} />
              <div className={styles.itemInfo}>
                <h3 className={styles.itemName}>{item.name}</h3>
                <span className={styles.itemPrice}>{formatPrice(item.price)} each</span>
              </div>
              <div className={styles.qtyControls}>
                <button className={styles.qtyBtn} onClick={() => updateQty(item.id, item.qty - 1)}>−</button>
                <span className={styles.qty}>{item.qty}</span>
                <button className={styles.qtyBtn} onClick={() => updateQty(item.id, item.qty + 1)}>+</button>
              </div>
              <span className={styles.subtotal}>{formatPrice(item.price * item.qty)}</span>
              <button className={styles.removeBtn} onClick={() => remove(item.id)} aria-label="Remove">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
            </div>
          ))}
        </div>

        {/* Summary */}
        <div className={styles.summary}>
          <h2 className={styles.summaryTitle}>Order summary</h2>
          <div className={styles.summaryRows}>
            <div className={styles.row}>
              <span>Subtotal ({count} items)</span>
              <span>{formatPrice(total)}</span>
            </div>
            <div className={styles.row}>
              <span>Delivery estimate</span>
              <span>{formatPrice(deliveryFee)}</span>
            </div>
            <p className={styles.deliveryNote}>
              Final delivery fee confirmed at checkout
            </p>
          </div>
          <div className={styles.total}>
            <span>Estimated total</span>
            <span>{formatPrice(grandTotal)}</span>
          </div>

          {!isLoggedIn && (
            <div className={styles.loginNotice}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              You'll be asked to sign in before checkout
            </div>
          )}

          <button className={styles.checkoutBtn} onClick={handleCheckout}>
            Proceed to checkout
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
            </svg>
          </button>

          <Link to="/shop" className={styles.continueBtn}>← Continue shopping</Link>
        </div>
      </div>
    </div>
  );
}
